<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'
import { usePlanningStore } from '@/stores/planning.store'

const props = defineProps({
  modelValue: { type: [Number, null], default: null },
  clearable: { type: Boolean, default: false },
})
defineEmits(['update:modelValue'])

const i18n = getI18n()
const planningStore = usePlanningStore()

const options = computed(() => {
  const all = planningStore.getListings()
  return all.filter(i => !i.archived || i.id === props.modelValue)
})
</script>

<template>
  <q-select
    :model-value="modelValue"
    :label="i18n.t('common.priceList')"
    option-value="id"
    option-label="name"
    :clearable="clearable"
    :options="options"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #option="scope">
      <q-item v-bind="scope.itemProps" :class="scope.opt.archived ? 'text-grey text-strike' : ''">
        <q-item-section>
          <q-item-label>{{ scope.opt.name }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>
